import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/fonts/avenir.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./providers/authProvider";
import { QuickTalesProvider } from "./providers/OrganizationAdmin/QuickTalesProvider";
import { ReactionsProvider } from "./providers/OrganizationAdmin/ReactionsProvider";
import { AlbumProvider } from "./providers/OrganizationAdmin/AlbumProvider";
import { AdminsProvider } from "./providers/OrganizationAdmin/AdminsProvider";
import { OrganizationProvider } from "./providers/OrganizationAdmin/OrganizationProvider";
import { ContributorsProvider } from "./providers/OrganizationAdmin/ContributorsProvider";
import { UsersProvider } from "./providers/OrganizationAdmin/UsersProvider";
import { AreaProvider } from "./providers/OrganizationAdmin/AreaProvider";
import { ContentModerationProvider } from "./providers/GeneralAdmin/ContentModerationProvider";
import { DashboardProvider } from "./providers/GeneralAdmin/DashboardProvider";
import { CommonProvider } from "./providers/CommonProvider";
import { NotificationBadgeProvider } from "./providers/NotificationBadgeProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <AuthProvider>
      <NotificationBadgeProvider>
        <AdminsProvider>
          <QuickTalesProvider>
            <ReactionsProvider>
              <AlbumProvider>
                <OrganizationProvider>
                  <ContributorsProvider>
                    <UsersProvider>
                      <AreaProvider>
                        <ContentModerationProvider>
                          <DashboardProvider>
                            <CommonProvider>
                              <App />
                            </CommonProvider>
                          </DashboardProvider>
                        </ContentModerationProvider>
                      </AreaProvider>
                    </UsersProvider>
                  </ContributorsProvider>
                </OrganizationProvider>
              </AlbumProvider>
            </ReactionsProvider>
          </QuickTalesProvider>
        </AdminsProvider>
      </NotificationBadgeProvider>
    </AuthProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
